import React from 'react';
import { MessageCircle, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { useFormModal } from './FormModalContext';

export const Header = () => {
  const [isScrolled, setIsScrolled] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const { openForm: open } = useFormModal();

  const openForm = () => {
    open();
    setIsMobileMenuOpen(false);
  };

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false); // Fecha o menu mobile ao clicar
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_fridge-plants-b2b/artifacts/iukyse34_Design%20sem%20nome%20%2813%29.png"
              alt="Plantinha de Geladeira"
              className="h-12 w-auto"
            />
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-[#eb068c]' : 'text-gray-800 hover:text-[#eb068c]'
              }`}
            >
              Quem Somos
            </button>
            <button 
              onClick={() => scrollToSection('benefits')}
              className={`font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-[#eb068c]' : 'text-gray-800 hover:text-[#eb068c]'
              }`}
            >
              Por que Escolher
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className={`font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-[#eb068c]' : 'text-gray-800 hover:text-[#eb068c]'
              }`}
            >
              Personalização
            </button>
            <button 
              onClick={() => scrollToSection('clients')}
              className={`font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-[#eb068c]' : 'text-gray-800 hover:text-[#eb068c]'
              }`}
            >
              Cases
            </button>
          </nav>

          {/* CTA Button + Mobile Menu - Aligned */}
          <div className="flex items-center gap-3">
            {/* CTA Button */}
            <Button
              onClick={openForm}
              data-testid="header-cta-form"
              className="bg-[#20BA5A] hover:bg-[#178C41] text-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 h-10 px-4 text-sm"
            >
              <MessageCircle className="mr-2 h-4 w-4" />
              <span className="hidden md:inline">Solicitar Orçamento</span>
              <span className="md:hidden">Contato</span>
            </Button>

            {/* Mobile menu button */}
            <button 
              className="md:hidden p-2 flex items-center justify-center"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Menu"
            >
              {isMobileMenuOpen ? (
                <X className={`h-6 w-6 ${isScrolled ? 'text-gray-700' : 'text-gray-900'}`} />
              ) : (
                <Menu className={`h-6 w-6 ${isScrolled ? 'text-gray-700' : 'text-gray-900'}`} />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Panel */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-xl border-t border-gray-200">
            <nav className="container mx-auto px-6 py-6 flex flex-col gap-4">
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-[#eb068c] font-medium text-left py-2 transition-colors"
              >
                Quem Somos
              </button>
              <button 
                onClick={() => scrollToSection('benefits')}
                className="text-gray-700 hover:text-[#eb068c] font-medium text-left py-2 transition-colors"
              >
                Por que Escolher
              </button>
              <button 
                onClick={() => scrollToSection('gallery')}
                className="text-gray-700 hover:text-[#eb068c] font-medium text-left py-2 transition-colors"
              >
                Personalização
              </button>
              <button 
                onClick={() => scrollToSection('clients')}
                className="text-gray-700 hover:text-[#eb068c] font-medium text-left py-2 transition-colors"
              >
                Cases
              </button>
              <div className="pt-4 border-t border-gray-200">
                <Button
                  onClick={openForm}
                  data-testid="header-mobile-cta-form"
                  className="w-full bg-[#20BA5A] hover:bg-[#178C41] text-white"
                >
                  <MessageCircle className="mr-2 h-4 w-4" />
                  Solicitar Orçamento
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
